import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import Qs from 'qs'

//import store from '../store/index'
/* 
*请求失败后的错误统一处理
*
*
*/

const errorMsg = (status, message, data) => {
    //状态码判断
    switch (status) {
        case 401:
            if (document.querySelector('.err-dialog')) return
            MessageBox({
                customClass: 'err-dialog',
                title: '提示：',
                confirmButtonText: '去登录',
                dangerouslyUseHTMLString: true,
                message: `登录过期，请重新登录！`,
                showClose: false,
                closeOnClickModal: false,
                callback(res) {
                    if (res === 'confirm') location.href = data.location
                }
            });
            break;
        case 403:
            Message.error('无权限');
            window.location.href = '/login'
            break;
        case 404:
            Message.error('请求的资源不存在');
            break;
        default:
    }

}



//设置axios实例
var instance = axios.create({
    /*  transformRequest: [function (data) {
         //对data进行转换处理
         return JSON.stringify(data)
     }], */
    timeout: 600000, //请求超时时间
    withCredentials: true,//跨域请求时是否需要使用凭证
});
//设置post请求头
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
/* 
*请求拦截器
*每次请求前。如果存在token责在请求头里携带token
 */
let str=['/api/v2/kb/kbxmdcbj/kqzcbj','/api/v2/kb/kbxmdcbj/dcbjquery','/api/v2/kb/kbxmdcbj/ispublish'];
instance.interceptors.request.use(
    config => {
        //登录流程控制中，根据本地是否存在token判断用户的登录情况
        //即使存在token，也可能过期了，所以每次请求的时候带上token
        //后台根据携带的token判断用户的登录情况，并返回对应的状态码
        //而后我们可以在响应拦截器中，根据状态码进行一些统一的操作
        if(str.includes(config.url)){
            config.headers['contentType'] = 'application/x-www-form-urlencoded';
        }
        return config;
    },
    error => Promise.error(error)
)
//响应拦截器
instance.interceptors.response.use(
    //请求成功
    res => {
        // 401
        if (res && res.data && res.data.meta && res.data.meta.code == 401) {
            errorMsg(401, res.data.meta.message, res.data)
            return
        }

        if (res.status === 200) {

            return Promise.resolve(res)
        } else {
            return Promise.reject(res)
        }
    },
    //请求失败
    error => {
        const { response } = error;
        if (response) {
            //请求已发出，但是不在2**的范围
            errorMsg(response.status, response.data.message, response)
            return Promise.reject(response);
        } else {
            //处理断网的情况
            //eg:请求超时或断网时，更新state的network状态
            //network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
            //关于断网组件中的刷新重新获取数据，会在断网组件中说明
            //           store.commit('changeNetwork',false)
        }
    }
)

export default instance;